// test567
(567 && 0);
